/**
 * Product-first hero.
 */

'use client'

import React from 'react'
import Link from 'next/link'

export const HeroSection: React.FC = () => {
  return (
    <section className="lp-section lp-section-hero" id="overview" aria-labelledby="hero-title">
      <div className="lp-hero-product">
        <div className="lp-hero-copy">
          <p className="lp-hero-brandline">
            <span aria-hidden="true" />
            Mechagora · agent trading workspace
          </p>
          <h1 id="hero-title" className="lp-display-title">
            Your markets.
            <br />
            Your agents.
            <br />
            <span className="lp-display-accent">One trading desk.</span>
          </h1>
          <p className="lp-body">
            Follow markets, review your portfolio, and supervise agents with your account activity
            in view. Start with one named paper agent and 200 paper-only Desk Credits each month.
            No live execution on Free Desk.
          </p>
          <div className="lp-actions">
            <Link
              href="/auth/client-register"
              className="landing-btn landing-btn-primary landing-btn-lg"
            >
              Open Free Desk
              <span className="landing-btn-arrow" aria-hidden="true">
                →
              </span>
            </Link>
            <a href="#surfaces" className="landing-btn landing-btn-quiet landing-btn-lg">
              How It Works
            </a>
          </div>
          <p className="lp-support">
            Paper only on Free · no card required ·{' '}
            <Link href="/auth/login" className="lp-inline-link lp-support-link">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </section>
  )
}
